import BlueSmiley0 from '../assets/BlueSmiley0.svg';
import BlueSmiley40 from '../assets/BlueSmiley40.svg';
import BlueSmiley60 from '../assets/BlueSmiley60.svg';
import BlueSmiley80 from '../assets/BlueSmiley80.svg';
import BlueSmiley100 from '../assets/BlueSmiley100.svg';
import { Person } from '../types';
import { useMonthlyInteraction } from './use-interaction';

interface UseProgressImageProps {
	progress: number;
}

export const useProgressImage = ({ progress }: UseProgressImageProps) => {
	const svgPos = {
		position: 'absolute',
		top: 0,
		left: `calc(${progress}% - ${progress * 0.01 * 24}px)`,
	} as React.CSSProperties;

	let face;

	switch (true) {
		case progress < 40:
			face = BlueSmiley0;
			break;
		case progress < 60:
			face = BlueSmiley40;
			break;
		case progress < 80:
			face = BlueSmiley60;
			break;
		case progress < 100:
			face = BlueSmiley80;
			break;
		default:
			face = BlueSmiley100;
			break;
	}

	return {
		face,
		svgPos,
	};
};

export const useRecognitionProgress = (people: Person[]) => {
	const directReportsTotal = people.length;

	// Recognition
	const { interactionPeopleInMonth: recognizedPeopleInMonth } = useMonthlyInteraction({ people, type: 'recognition' });
	const directReportsRecognized = recognizedPeopleInMonth.length;

	const recognitionProgress = directReportsTotal < 1 ? 0 : (directReportsRecognized / directReportsTotal) * 100;

	// We have to correct for the width of the SVG
	const recognitionVisualProgress = recognitionProgress + (100 - recognitionProgress) * 0.01 * 9;

	const { face: recognitionFace, svgPos: recognitionSvgPos } = useProgressImage({
		progress: recognitionProgress,
	});

	return {
		directReportsRecognized,
		directReportsTotal,
		recognitionFace,
		recognitionSvgPos,
		recognitionProgress,
		recognitionVisualProgress,
	};
};
